export enum DisplayType {
    RADIO = 'radio',
    SELECT = 'select',
    COLOR = 'color',
    LABEL = 'label'
}
